<template>
  <div class="container">
    <div v-if="loaded">
      <div class="top">
        <div class="c-top">
          <div class="c-title">我的{{ data.title }}</div>
          <div class="c-unit" v-if="data.unit">单位：{{ data.unit }}</div>
        </div>
        <!-- 折线图 -->
        <div class="canvas-center">
          <div class="canvas-container">
            <line-canvas :data="navData.data" v-if="navData.data"></line-canvas>
            <div class="not-data" v-if="!navData.dataLength">
              <div class="desc1">暂无记录</div>
              <div class="desc2">瘦身，从学会观察自我变化曲线开始</div>
            </div>
          </div>
          <div class="canvas-tips">
            <div class="before"></div>
            <div class="tip">已自动筛选当日最新数据</div>
            <div class="after"></div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <HistoryComponent
          :data="historyList"
          :unit="data.unit"
          :field="data.field"
          :title="data.title"
          :finished="finished"
          :rulerOptions="data.rulerOptions"
        />
      </div>
    </div>
    <van-loading
      class="v-loading"
      v-else
      text-color="#4a3d6b"
      color="#4a3d6b"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>
<script>
import LineCanvas from '../line-canvas/line-canvas.vue'
import HistoryComponent from './history-component.vue'
export default {
  components: {
    LineCanvas,
    HistoryComponent
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loaded: false,
      historyLoading: false, //历史记录是否在加载
      finished: false,
      curNav: 0,
      page: 1,
      historyList: [],
      navData: {
        title: '近一月',
        index: 1,
        dataLength: 0,
        type: 'day',
        loaded: false,
        data: null
      }
    }
  },
  created() {
    this.getHistory()
  },
  mounted() {
    this.getWeight()
  },
  methods: {
    //根据id删除记录
    delRecord(id) {
      for (let i = 0; i < this.historyList.length; i++) {
        if (id == this.historyList[i].id) {
          this.historyList.splice(i, 1)
          break
        }
      }
      this.getWeight(this.navData.type, this.curNav)
    },
    //编辑记录
    editRecord(id, value) {
      for (let i = 0; i < this.historyList.length; i++) {
        if (id == this.historyList[i].id) {
          this.historyList[i].data_value = (+value).toFixed(1)
          break
        }
      }
      this.getWeight(this.navData.type, this.curNav)
    },
    //更新记录
    updateRecord(value) {
      console.log('更新了体重' + value)
      this.setRecord(value)
    },
    setRecord(value) {
      let params = {
        field: this.data.field,
        value: value
      }
      this.$http
        .getApp('member/BodyData/modifyField', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast('添加成功')
            this.page = 1
            this.finished = false
            this.navData.loaded = false
            this.getHistory(true)
            this.getWeight(this.navData.type, this.curNav)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    changeNav(index) {
      this.curNav = index
    },
    getWeight() {
      console.log('获取体重')
      let params = {
        field: this.data.field,
        type_id: 0
      }
      this.$http
        .getBaseApp('member/BodyData/detail', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.navData.dataLength = res.data.data.length
            this.navData.data = this.dealDayData(res.data.data)
            this.navData.loaded = true
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.loaded = true
        })
    },
    dealDayData(arr) {
      let xList = []
      let yList = []
      arr.map((item) => {
        xList.push(this.formatDay(item.day))
        yList.push(item.value)
      })
      if (arr.length < 7) {
        let len = 7 - arr.length
        for (let i = 0; i < len; i++) {
          xList.push('')
          yList.push(null)
        }
      }
      let res = {
        xList,
        yList
      }
      return res
    },
    //处理天数显示方式
    formatDay(str) {
      let res
      str = str.replace(/-/g, '/')
      let difference = new Date().getTime() - new Date(str).getTime()
      let isToday = difference >= 0 && difference <= 1000 * 60 * 60 * 24
      if (isToday) {
        res = '今日'
      } else {
        let arr = str.split('/')
        res = arr[1] + '/' + arr[2]
      }
      return res
    },
    getHistory(isCover) {
      if (this.historyLoading || this.finished) {
        return
      }
      this.historyLoading = true
      let lastId = this.historyList.length
        ? this.historyList[this.historyList.length - 1].id
        : 0
      lastId = isCover ? 0 : lastId
      let params = {
        last_id: lastId,
        page_num: 30,
        data_field: this.data.field
      }
      this.$http
        .getApp('member/UserBodyData/getUserHistoryPhysicalIndicators', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (isCover) {
              this.historyList = this.dealHistoryList(res.data)
            } else {
              this.historyList = this.historyList.concat(
                this.dealHistoryList(res.data)
              )
            }
            if (!res.data || !res.data.length) {
              this.finished = true
            }
            this.page++
          }
        })
        .catch(() => {})
        .finally(() => {
          this.historyLoading = false
        })
    },
    dealHistoryList(data) {
      data.map((item) => {
        item.showPopover = false
      })
      return data
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  background: #f9f9f9;
  min-height: 100%;
  box-sizing: border-box;
  padding-bottom: 50px;
}
.c-center {
  display: flex;
  //padding: 0px 14px;
  box-sizing: border-box;
  text-align: center;
  .c-center-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
  }
  .c-line {
    border-right: 1px solid #efefef;
  }
  .c-text {
    white-space: nowrap;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.7);
    line-height: 17px;
    margin-bottom: 9px;
  }
  .c-unit-num {
    white-space: nowrap;
    height: 32px;
    font-size: 32px;
    font-family: DINCondensed-Bold, DINCondensed;
    font-weight: bold;
    color: #fff;
    line-height: 28px;
    .iconfont {
      font-size: 10px;
      color: rgba(53, 199, 99, 1);
    }
  }
  .cur-weight {
    height: 66px;
    font-size: 66px;
    font-family: DINCondensed-Bold, DINCondensed;
    font-weight: bold;
    color: #ffffff;
    line-height: 54px;
  }
  .c-change {
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #6236ff;
    line-height: 17px;
  }
  .icon-item {
    margin-bottom: 10px;
    color: #000;
    font-size: 22px;
  }
  .gray-content {
    margin: 0 auto;
    width: 296px;
    background: #f7f7f7;
    border-radius: 8px;
    display: flex;
    padding: 10px 0px;
    align-items: center;
    margin-bottom: 12px;
    .c-center-item {
      flex: 1;
    }
    .line {
      width: 2px;
      height: 39px;
      background-color: #ebebeb;
    }
  }
}
.nav-content {
  padding-right: 20px;
  display: flex;
  justify-content: flex-end;
  .nav-list {
    display: flex;
    align-items: center;
  }
  .nav-item {
    padding: 2px 10px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.5);
    line-height: 17px;
  }
  .nav-item-line {
    width: 1px;
    height: 10px;
    background-color: rgba(255, 255, 255, 0.3);
  }
  .nav-item-active {
    font-weight: 500;
    color: #fff;
  }
}
.top {
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  padding: 0px 20px 20px;
  box-sizing: border-box;
  background: #4a3d6b;
}
.c-top {
  display: flex;
  align-items: center;
  margin-bottom: 22px;
  box-sizing: border-box;
  .c-title {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 25px;
  }
  .c-unit {
    flex: 1;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.7);
    line-height: 17px;
    margin-left: 10px;
    margin-right: 10px;
  }
  .c-btn {
    height: 25px;
    line-height: 25px;
    padding: 0px 12px;
    background: #ffffff;
    border-radius: 10px;
    border: 2px solid #6236ff;
    font-size: 13px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #6236ff;
  }
}
.canvas-center {
  width: 100%;
  height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.canvas-container {
  position: relative;
  flex: 1;
  flex-shrink: 0;
  width: 100%;
  .not-data {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .desc1 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #ffffff;
      line-height: 20px;
      margin-bottom: 4px;
    }
    .desc2 {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.7);
      line-height: 17px;
    }
  }
}
.weight-desc {
  background: #ffffff;
  border-radius: 12px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
  line-height: 22px;
  padding: 15px 20px;
  box-sizing: border-box;
  margin-bottom: 16px;
  .desc-title {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 20px;
    margin-bottom: 10px;
  }
  .desc-item {
    margin-bottom: 10px;
  }
  .desc-item:last-child {
    margin-bottom: 0px;
  }
  .pink {
    color: #ff8c9c;
  }
}
.canvas-tips {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  .before,
  .after {
    width: 13px;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.5);
  }
  .tip {
    height: 17px;
    font-size: 12px;
    margin: 0px 8px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(255, 255, 255, 0.9);
    line-height: 17px;
  }
}
.v-loading {
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
}
.bottom {
  padding: 20px 20px 24px;
  box-sizing: border-box;
  background: #f9f9f9;
}
</style>
